module.exports = __webpack_public_path__ + "media/images/how-it-works/jumbotron-dcb966eb2f85512e3702c37f5adef5cc.png";